import React, { useEffect, useId, useState } from "react";
import { getElectronAPI } from "../../../adapters/electron";
import { useSatchelWalletContext } from "../../../hooks/SatchelWalletContext";
import { NetworkPill } from "./NetworkPill";
import { ShardStatusPill } from "./ShardStatusPill";

/** The networks SATCHEL is on: Bitcoin, Ethereum (desktop only) and the F1r3fly shard. */
export const NetworkStatus: React.FC = () => {
  const wallet = useSatchelWalletContext();
  const headingId = useId();
  const [ethereum, setEthereum] = useState<string | null>(null);

  useEffect(() => {
    const evm = getElectronAPI()?.evm;
    if (!evm) return;
    let current = true;
    evm.getNetwork().then(
      (network) => current && setEthereum(network.name),
      () => current && setEthereum(null),
    );
    return () => {
      current = false;
    };
  }, []);

  return (
    <section aria-labelledby={headingId}>
      <p
        id={headingId}
        className="mb-2 px-3 text-xs font-semibold uppercase tracking-wide text-sa-text-dim"
      >
        Networks
      </p>
      <div className="flex flex-wrap gap-1.5 px-3">
        <NetworkPill>Bitcoin {wallet.network}</NetworkPill>
        {ethereum && <NetworkPill>{ethereum}</NetworkPill>}
        <ShardStatusPill api={wallet.api} />
      </div>
    </section>
  );
};
